import { useQuery } from "@tanstack/react-query";
import _cookies from "../../../shared/utils/_cookies";

export const getSocialMediaPost = async (params) => {
  const urlSearchParams = new URLSearchParams({
    ...params,
    alunoid: _cookies.getItem("auth").user?.alunoid,
  }).toString();

  const res = await fetch(
    "https://middleware.cadernovirtual.com.br/Social.asmx/DadosPostagemFeed?" +
      urlSearchParams,
    {
      headers: {
        "Content-Type": "application/json",
        token: _cookies.getItem("auth").token,
      },
    }
  );
  const data = await res.json();
  return data.d.result[0];
};

export const useSocialMediaPost = ({ config, params } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["socialMediaPost", params],
    queryFn: () => getSocialMediaPost(params),
  });
};
